"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadMembershipTemplates = exports.FetchMembershipTemplates = exports.FetchMembershipTemplatesActionTypes = exports.loadStylesheets = exports.FetchStylesheets = exports.FetchStylesheetsActionTypes = exports.loadBlogTemplates = exports.FetchBlogTemplates = exports.FetchBlogTemplatesActionTypes = exports.loadSystemTemplates = exports.FetchSystemTemplates = exports.FetchSystemTemplatesActionTypes = exports.loadSubscriptionTemplates = exports.FetchSubscriptionTemplates = exports.FetchSubscriptionTemplatesActionTypes = exports.DesignTemplatesActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var DesignTemplatesActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_SUBSCRIPTION_TEMPLATES: null,
  LOAD_SUBSCRIPTION_TEMPLATES: null,
  FETCH_SYSTEM_TEMPLATES: null,
  LOAD_SYSTEM_TEMPLATES: null,
  FETCH_BLOG_TEMPLATES: null,
  LOAD_BLOG_TEMPLATES: null,
  LOAD_STYLESHEETS: null,
  FETCH_STYLESHEETS: null,
  FETCH_MEMBERSHIP_TEMPLATES: null,
  LOAD_MEMBERSHIP_TEMPLATES: null
}, _UrlPathParams.PAGES);
exports.DesignTemplatesActionTypes = DesignTemplatesActionTypes;
var FetchSubscriptionTemplatesActionTypes = (0, _actions.createRequestTypes)(DesignTemplatesActionTypes.FETCH_SUBSCRIPTION_TEMPLATES);
exports.FetchSubscriptionTemplatesActionTypes = FetchSubscriptionTemplatesActionTypes;
var FetchSubscriptionTemplates = (0, _actions.createRequestActions)(FetchSubscriptionTemplatesActionTypes);
exports.FetchSubscriptionTemplates = FetchSubscriptionTemplates;
var loadSubscriptionTemplates = (0, _fluxActions.createAction)(DesignTemplatesActionTypes.LOAD_SUBSCRIPTION_TEMPLATES);
exports.loadSubscriptionTemplates = loadSubscriptionTemplates;
var FetchSystemTemplatesActionTypes = (0, _actions.createRequestTypes)(DesignTemplatesActionTypes.FETCH_SYSTEM_TEMPLATES);
exports.FetchSystemTemplatesActionTypes = FetchSystemTemplatesActionTypes;
var FetchSystemTemplates = (0, _actions.createRequestActions)(FetchSystemTemplatesActionTypes);
exports.FetchSystemTemplates = FetchSystemTemplates;
var loadSystemTemplates = (0, _fluxActions.createAction)(DesignTemplatesActionTypes.LOAD_SYSTEM_TEMPLATES);
exports.loadSystemTemplates = loadSystemTemplates;
var FetchBlogTemplatesActionTypes = (0, _actions.createRequestTypes)(DesignTemplatesActionTypes.FETCH_BLOG_TEMPLATES);
exports.FetchBlogTemplatesActionTypes = FetchBlogTemplatesActionTypes;
var FetchBlogTemplates = (0, _actions.createRequestActions)(FetchBlogTemplatesActionTypes);
exports.FetchBlogTemplates = FetchBlogTemplates;
var loadBlogTemplates = (0, _fluxActions.createAction)(DesignTemplatesActionTypes.LOAD_BLOG_TEMPLATES);
exports.loadBlogTemplates = loadBlogTemplates;
var FetchStylesheetsActionTypes = (0, _actions.createRequestTypes)(DesignTemplatesActionTypes.FETCH_STYLESHEETS);
exports.FetchStylesheetsActionTypes = FetchStylesheetsActionTypes;
var FetchStylesheets = (0, _actions.createRequestActions)(FetchStylesheetsActionTypes);
exports.FetchStylesheets = FetchStylesheets;
var loadStylesheets = (0, _fluxActions.createAction)(DesignTemplatesActionTypes.LOAD_STYLESHEETS);
exports.loadStylesheets = loadStylesheets;
var FetchMembershipTemplatesActionTypes = (0, _actions.createRequestTypes)(DesignTemplatesActionTypes.FETCH_MEMBERSHIP_TEMPLATES);
exports.FetchMembershipTemplatesActionTypes = FetchMembershipTemplatesActionTypes;
var FetchMembershipTemplates = (0, _actions.createRequestActions)(FetchMembershipTemplatesActionTypes);
exports.FetchMembershipTemplates = FetchMembershipTemplates;
var loadMembershipTemplates = (0, _fluxActions.createAction)(DesignTemplatesActionTypes.LOAD_MEMBERSHIP_TEMPLATES);
exports.loadMembershipTemplates = loadMembershipTemplates;